import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useMemo,
    useState,
} from "react";
import { GridRowModes } from "@mui/x-data-grid";
import { newRow } from "./constants";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { editCellContainerStyle } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { saveOrDeleteMsg } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { isObjEmpty } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { generateRandomId } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import { Tooltip } from "@mui/material";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import CustomChip from "views/pages/manage/common/customChip/CustomChip";
import { regex } from "views/pages/manage/common/constant/regex/index";
import StatusCellComponent from 'views/pages/manage/masters/studentFinancials/paymentCollectionSetup/securityDepositSequencing/StatusCellComponent.jsx';
import { getStatusStyles } from 'modules/studentTransfer/transferSetup/transferValidationConfig/constant.js'
import { selectStyles, inputStyles } from "modules/studentRefund/thirdPartyBankAccMaster/constants";
import ALoader from "views/pages/manage/common/a-loader";
import { LastUpdatedDetails, getFormattedDate } from "views/pages/manage/employeeManagement/userProfile/helper";

const ListComponent = forwardRef(
    (
        {
            rows,
            rowCount,
            isLoading,
            setIsLoading,
            nextButtonHandler,
            dropdowns,
            isUpdatePermission,
            currentPage = 0,
            currPageSize,
            toggleStatusHandler
        },
        ref
    ) => {

        const [rowModesModel, setRowModesModel] = useState({});

        const [rowData, setRowData] = useState(rows);
        const [rowForm, setRowForm] = useState({});

        useEffect(() => setRowData(rows), [rows]);

        const rowFormHandler = (value, key) =>
            setRowForm((prev) => ({ ...prev, [key]: value }));

        const startEditing = (id, form) => {
            setRowModesModel((oldModel) => ({ [id]: { mode: GridRowModes.Edit } }));
            setRowForm(form);
        };


        const stopEditing = () => {
            const currForm = { ...rowForm };
            setRowModesModel((oldModel) => ({
                [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
            }));
            setRowForm({});
        };

        const handleEditClick = (params) => {
            if (!isObjEmpty(rowForm)) {
                failureToast(saveOrDeleteMsg);
            } else {
                startEditing(params?.id, params?.row);
            }
        };

        const handleCancelClick = async (params) => {
            if (params?.row?.isNew) {
                setRowData(rows);
                setRowForm({});
            } else {
                stopEditing(params?.id);
            }
        };

        const handleSaveClick = async (params) => {
            // createUpdateHandler(rowForm);
        };

        const addNewRow = async () => {
            if (!isObjEmpty(rowForm)) {
                failureToast(saveOrDeleteMsg);
            } else {
                let randomId = generateRandomId();
                let emptyRow = {
                    ...newRow,
                    isNew: true,
                    id: randomId
                };
                startEditing(randomId, emptyRow);
                setRowData((prev) => [emptyRow, ...prev]);
            }
        };

        useImperativeHandle(ref, () => ({
            addNewRow: addNewRow,
            startEditing: startEditing,
            stopEditing: stopEditing,
        }));

        const columns = useMemo(() => [
            new AGridColDef("companyCode", "Company Code", false)
                .setMinWidth(60)
                .editable(true)
                .setFlex(0.4)
                .renderCellComponent((params) => (
                    params?.value ? <div><Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip></div> : <div>-</div>
                ))
            // .renderEditCellComponent((params) => (
            //     <div style={editCellContainerStyle}>
            //         <AAutoComplete
            //             currentValue={rowForm?.companyCode}
            //             handleChange={(value) => rowFormHandler(value, "companyCode")}
            //             items={dropdowns?.companyCode}
            //             isMulti={false}
            //             style={selectStyles}
            //             autoFocus={params?.hasFocus}
            //         />
            //     </div>
            // ))
            ,
            new AGridColDef("accountNumber", "Account", false)
                .setMinWidth(80)
                .editable(true)
                .setFlex(0.4)
                .renderCellComponent((params) => (
                    params?.value !== null && params?.value !== undefined ?
                        <div><Tooltip title={params?.value}>
                            <div className={`ellipsis-text-container`}>{params?.value}</div>
                        </Tooltip></div> : <div>-</div>
                ))
            // .renderEditCellComponent((params) => (
            //     <div style={editCellContainerStyle}>
            //         <AInput
            //             value={rowForm?.accountNumber}
            //             handler={(val) => {
            //                 if (val === "" || val === null) {
            //                     rowFormHandler("", "accountNumber");
            //                 } else if (val >= 0 && val <= 999) {
            //                     rowFormHandler(val, "accountNumber");
            //                 }
            //             }}
            //             placeholder={""}
            //             disabled={false}
            //             style={inputStyles}
            //             regex={regex?.numeric}
            //         />
            //     </div>))
            ,
            new AGridColDef("description", "Description", false)
                .setMinWidth(150)
                .editable(true)
                .setFlex(0.6)
                .renderCellComponent((params) => (
                    params?.value !== null && params?.value !== undefined ?
                        <div><Tooltip title={params?.value}>
                            <div className={`ellipsis-text-container`}>{params?.value}</div>
                        </Tooltip></div> : <div>-</div>
                ))
            // .renderEditCellComponent((params) => (
            //     <div style={editCellContainerStyle}>
            //         <AInput
            //             value={rowForm?.description}
            //             handler={(val) => {
            //                 if (val === "" || val === null) {
            //                     rowFormHandler("", "description");
            //                 } else {
            //                     rowFormHandler(val, "description");
            //                 }
            //             }}
            //             placeholder={""}
            //             disabled={false}
            //             style={inputStyles}
            //             regex={regex?.numeric}
            //         />
            //     </div>))
            ,
            new AGridColDef("shortDescription", "Short Description", false)
                .setMinWidth(150)
                .editable(true)
                .setFlex(0.6)
                .renderCellComponent((params) => (
                    params?.value !== null && params?.value !== undefined ?
                        <div><Tooltip title={params?.value}>
                            <div className={`ellipsis-text-container`}>{params?.value}</div>
                        </Tooltip></div> : <div>-</div>
                ))
            // .renderEditCellComponent((params) => (
            //     <div style={editCellContainerStyle}>
            //         <AInput
            //             value={rowForm?.shortDescription}
            //             handler={(val) => {
            //                 if (val === "" || val === null) {
            //                     rowFormHandler("", "shortDescription");
            //                 } else {
            //                     rowFormHandler(val, "shortDescription");
            //                 }
            //             }}
            //             placeholder={""}
            //             disabled={false}
            //             style={inputStyles}
            //             regex={regex?.numeric}
            //         />
            //     </div>))
            ,
            new AGridColDef("status", "Status", false)
                .setMinWidth(60)
                .setFlex(0.3)
                .editable(true)
                .renderCellComponent((params) => (
                    <CustomChip
                        text={params?.value}
                        textColor={getStatusStyles(params?.value)?.textColor}
                        bgColor={getStatusStyles(params?.value)?.bgColor}
                    />
                )),
            // .renderEditCellComponent((params) => (<StatusCellComponent
            //     params={params}
            //     toggleStatusHandler={toggleStatusHandler}
            //     rowForm={rowForm}
            //     rowFormHandler={rowFormHandler}
            // />
            // ))
            ,
            // new AGridColDef("actions", "Actions", false)
            //     .setMinWidth(130)
            //     .columnAlign("right")
            //     .setFlex(1)
            //     .renderCellComponent((params) => (
            //         <div className='d-flex align-items-center' style={{ gap: '15px' }}>
            //             <ActionsCellComponent
            //                 mode={params.api.getRowMode(params?.id)}
            //                 params={params}
            //                 handleEditClick={handleEditClick}
            //                 handleCancelClick={handleCancelClick}
            //                 handleSaveClick={handleSaveClick}
            //                 rowForm={rowForm}
            //                 icon={true}
            //                 cancelIcon={<CancelIcon
            //                     className="mx-2 cursor"
            //                     onClick={() => handleCancelClick(params)}
            //                 />
            //                 }
            //                 editPermission={isUpdatePermission}
            //                 customEditIcon
            //                 isSaveDisabled={false}
            //             />
            //         </div>

            //     ))
            new AGridColDef("updatedOn", "Last Updated On", false)
                .setMinWidth(250)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) =>
                    params?.value ? (
                        <Tooltip
                            title={LastUpdatedDetails(params?.value, params?.row.updatedBy)}
                        >
                            <div className={`ellipsis-text-container`}>
                                {LastUpdatedDetails(params?.value, params?.row.updatedBy)}
                            </div>
                        </Tooltip>
                    ) : (
                        <div>-</div>
                    )
                ),
        ], []);


        return (
            <>
                {isLoading && <ALoader position="fixed" />}
                <div className="mt-3">
                    <ADataGrid
                        removeWrapperContainer
                        rowModesModel={rowModesModel}
                        rows={rowData || []}
                        columns={columns}
                        rowId={(row) => row?.id}
                        rowHeight={50}
                        rowCount={rowCount}
                        loading={false}
                        currentPage={currentPage}
                        nextButtonHandler={nextButtonHandler}
                        sx={{
                            ...gridStyles,
                        }}
                        autoHeight
                        paginationModel={{ page: currentPage, pageSize: currPageSize }}
                    />
                </div>
            </>
        );
    }
);

export default ListComponent;